"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "辽高e学院在线培训平台",
    "captchaNotEmpty": "验证码不能为空",
    "accountNotEmpty": "账号不能为空",
    "passwordBits": "密码长度不能小于6位",
    "incorrectTips": "用户名或密码输入错误",
    "sign": "登录",
    "passwordNotEmpty": "密码不能为空",
    "passwordBitsLong": "密码长度不能大于18位",
    "captchaTips": "验证码输入错误",
    "confirmNot": "所填密码和确认密码不一致",
    "inputAccount": "请输入账号",
    "inputPassword": "请输入密码",
    "inputCaptcha": "请输入验证码",
    "forgetPassword": "忘记密码",
    "nextStep": "下一步",
    "inputUserName": "请输入用户名",
    "phoneNumber": "手机号",
    "phoneEmpty": "手机号不能为空",
    "surePasswordEmpty": "确认密码不能为空",
    "userNameEmpty": "用户名不能为空",
    "getCaptcha": "获取验证码",
    "msgCaptcha": "短信验证码",
    "prevStep": "上一步",
    "surePassword": "请确认密码",
    "reset": "重置",
    "resetSuccess": "重置成功",
    "resetSuccessTips": "您已重置密码成功，请前往登录",
    "loginNow": "立即登陆",
    "copyRight": "版权由×××××××××所有，Copyright@2020 京ICP备案",
    "loginFail": "登录失败，请重试!",
    "captchaFail": "验证码校验失败",
    "failTips": "校验失败",
    "inputOrigPassword": "请输入原密码",
    "inputNewPassowrd": "请输入新密码",
    "confimPassword": "请确认密码",
    "sure": "确定",
    "cancel": "取消",
    "changePasswordSuccess": "修改密码成功",
    "continueLogin": "重新登录",
    "resetLoginTips": "您已修改密码成功，需要重新登录，3秒后自动退出",
    "passwordFormat": "密码长度8到32位，包含数字和大小写字母",
    "changePassword": "修改密码",
    "poor": "弱",
    "middle": "中",
    "strong": "强",
    "logout": "登出成功",
    "formerPhone": "原手机号",
    "newPhone": "新手机号",
    "changePhoneSuccess": "修改手机号成功",
    "changePhoneSuccessTips": "您已修改手机号成功",
    "goHome": "前往首页",
    "changePhone": "修改手机号",
    "newPhoneEmpty": "新手机号不能为空",
    "newPhoneFomat": "新手机号格式不正确",
    "newPhoneSupport": "新手机号不能与原手机号一致",
    "newPhoneBinded": "新手机号已绑定",
    "orgPhoneEmpty": "原手机号不能为空",
    "orgPhoneFormat": "原手机号格式不正确",
    "orgPhoneNot": "原手机号不正确",
    "resetPassword": "重置密码",
    "phoneCaptchaEmpty": "手机验证码不能为空",
    "accountVerif": "账号验证",
    "phoneVerif": "手机验证",
    "resetDone": "重置完成",
    "phoneFormat": "手机号格式不正确",
    "phoneBinded": "手机号已绑定",
    "loginVertif": "登录验证",
    "clickGoHome": "点击返回登录页",
    "bingPhoneSuccess": "绑定手机号成功",
    "rightMessageChange": "您可以在导航栏右侧的个人信息处修改",
    "bingPhone": "绑定手机号"
  },
  "index": {
    "setAsHomePage": "设为首页",
    "addCollection": "加入收藏夹",
    "telephone": "咨询电话",
    "Help": "帮助中心",
    "SystemMessage": "系统提醒",
    "message": "消息",
    "emptyMessage": "清空",
    "checkAllMessage": "查看全部",
    "noMessage": "暂无数据",
    "fullScreen": "全屏展示",
    "ExitSystem": "退出此系统",
    "back": "返回",
    "top": "顶部",
    "backToTop": "返回顶部",
    "homePage": "首页",
    "course": "课程学习",
    "onlineCourse": "网上专题班",
    "faceCourse": "面授培训班",
    "examPractice": "考试练习",
    "dataDownLoad": "资源下载",
    "userInfo": "个人中心",
    "Administration": "管理后台",
    "courseCategory": "课程分类",
    "examIsOver": "的考核完成",
    "onlineHours": "在线学时",
    "faceHours": "面授学时",
    "notice": "通知公告",
    "checkAllNotice": "查看全部",
    "backToTopButton": "返回顶部",
    "recommendCourse": "推荐课程",
    "impotentCourse": "重点课程",
    "newCourse": "最新课程",
    "hotCourse": "最热课程",
    "requiredCourses": "必修课",
    "electiveCourses": "选修课",
    "startStudy": "开始学习",
    "continueStudy": "继续学习",
    "coursesRanking": "选课排行榜",
    "studentRanking": "学员排行榜",
    "currentUser": "当前用户",
    "userHead": "用户头像",
    "currentHead": "当前头像",
    "change": "修改",
    "accountPassword": "账户密码",
    "encryPhone": "密保手机",
    "currentPhone": "当前手机",
    "userName": "用户名",
    "head": "头像",
    "coverImage": "封面图片",
    "uploadError": "上传失败",
    "autoSetHomeTips": "您的浏览器不支持自动自动设置首页, 请使用浏览器菜单手动设置!",
    "operateConfig": "该操作被浏览器拒绝，假如想启用该功能，请在地址栏内输入 about:config,然后将项 signed.applets.codebase_principal_support 值该为true",
    "favoriteTips": "由于360浏览器功能限制，请按 Ctrl+D 手动收藏！",
    "autoFavorite": "您的浏览器不支持,请按 Ctrl+D 手动收藏!",
    "required": "此项必填",
    "to": "至",
    "trainingTime": "培训时间",
    "coursehours": "学时",
    "human": "人",
    "wecome": "欢迎您！",
    "allCourses": "全部课程"
  },
  "course": {
    "coursesCategory": "课程分类",
    "allCourses": "全部课程",
    "electiveCourses": "选修课程",
    "requiredCourses": "必修课程",
    "collect": "收藏",
    "cancelCollect": "取消收藏",
    "searchTips": "请输入课程名称",
    "startStudy": "开始学习",
    "continueStudy": "继续学习",
    "cancelConfirm": "取消收藏",
    "cancelTips": "是否确认取消提示",
    "confirmButton": "取消按钮",
    "count": "共",
    "item": "条",
    "up": "上一页",
    "next": "下一页",
    "items": "条/页",
    "go": "跳至",
    "page": "页",
    "man": "人",
    "score": "分",
    "courseYear": "年",
    "courseTeachers": "教师",
    "noDesc": "暂无简介",
    "teachersDesc": "教师简介",
    "checkLog": "查看记录",
    "reExam": "重新考试",
    "examLog": "考试记录",
    "viewPaper": "查看试卷",
    "noPublicExam": "此次试卷不公布",
    "marking": "阅卷中",
    "closeButton": "关闭",
    "examResultPage": "考试结果页面",
    "examPage": "考试页面",
    "startExam": "开始考试",
    "coursehours": "学时",
    "courseInfo": "课程详情",
    "courseChapter": "课程章节",
    "courseNote": "课程笔记",
    "courseData": "课程资料",
    "courseExamination": "随课考试",
    "evaluate": "评价",
    "courseEvaluate": "课程评价",
    "no": "第",
    "chapter": "章",
    "isEvaluate": "已评价",
    "uploadDate": "上传时间",
    "className": "班级名称",
    "resourceSize": "资源大小",
    "donwButton": "下&nbsp;载",
    "times": "次",
    "typeViedo": "视频",
    "typeImage": "图片",
    "typeDoc": "文档",
    "typeOuth": "其他",
    "typeImages": "多图片",
    "newComment": "最新",
    "hotComment": "最热",
    "openComment": "我要评论",
    "cancelButton": "取消",
    "publishButton": "发布",
    "commentTips": "请输入评论内容",
    "emptyCommentTips": "评论内容不能为空",
    "noteSource": "源自",
    "deleteNoteButton": "删除",
    "needIETips": "当前课件需要使用IE浏览器！",
    "donwNum": "下载次数",
    "preview": "预览",
    "relatedCourses": "相关课程",
    "studentsNum": "选课人数",
    "courseHours": "课程学时",
    "JoinLearning": "加入学习"
  },
  "onlineclass": {
    "allTheClass": "全部班级",
    "beginClass": "已开班",
    "notBeginClass": "未开班",
    "endClass": "已结班",
    "searchThoseClass": "搜索你感兴趣的网上专题班",
    "startLearn": "进入班级",
    "registrationTime": "报名时间",
    "to": "至",
    "trainingTime": "培训时间",
    "subjectsClass": "门课",
    "classStudy": "班级学习",
    "quantityOfCourses": "课程数量",
    "numberOfParticipants": "报名人数",
    "registerNow": "立即报名",
    "resetRegister": "撤回报名",
    "participating": "已参加",
    "subjects": "门",
    "classExam": "班级考试",
    "notParticipat": "未参与",
    "startExim": "开始考试",
    "handed": "交卷",
    "score": "得分",
    "cacheSave": "暂存",
    "subjectsNumber": "门数",
    "notice": "通知",
    "communication": "通讯",
    "detail": "详情",
    "courses": "课程",
    "allClass": "全部",
    "compulsory": "必修",
    "elective": "选修",
    "Learned": "已学习",
    "classPassIndicator": "班级通过指标",
    "excellence": "优秀",
    "compulsoryNumber": "必修通过数量",
    "electiveNumber": "选修通过数量",
    "compulsoryStandard": "必修达标学时",
    "electiveStandard": "选修达标学时",
    "examIsPass": "考试是否通过",
    "resource": "资源",
    "source": "资料",
    "new": "最新",
    "hot": "最热",
    "updateTime": "上传时间",
    "downloadCount": "下载量",
    "download": "下载",
    "resourceSize": "资源大小",
    "resourceType": "类型",
    "allType": "全部类型",
    "videos": "视频",
    "images": "图片",
    "document": "文档",
    "others": "其他",
    "multiImages": "多图片",
    "inforCertificate": "证书",
    "notSubmit": "未提交",
    "submitHomework": "提交作业",
    "submitTime": "提交时间",
    "uploadHomework": "上传作业",
    "clickHere": "点击这里",
    "upload": "上传",
    "formatSupport": "文件格式支持",
    "submited": "已提交",
    "notApproved": "未审核",
    "approved": "审核通过",
    "downloadHomework": "下载作业",
    "reSubmit": "重新提交",
    "myScore": "我的得分",
    "comments": "评语",
    "talk": "讨论",
    "category": "分类",
    "classTalk": "班级讨论",
    "groupTalk": "小组讨论",
    "wantTalk": "我要讨论",
    "publish": "发布",
    "undo": "取消",
    "delete": "删除",
    "iknow": "我知道啦",
    "faceCourseClass": "面授培训班",
    "onlineClasses": "网上专题班",
    "openReservation": "开放报名",
    "talkTech": "讲师",
    "address": "地点",
    "up": "上",
    "noon": "午",
    "down": "下",
    "even": "晚",
    "classOvered": "班级已结班",
    "nopassed": "尚未报名通过",
    "inputTalkContent": "请输入讨论内容",
    "groupMan": "组长",
    "showAllGroup": "查看全部组员",
    "hideAllGroup": "收起全部组员",
    "showAllMan": "查看全部学员",
    "hideAllMan": "收起全部学员",
    "reply": "回复",
    "isDelete": "是否确认删除？",
    "cancelLike": "取消点赞",
    "classNotStar": "班级报名尚未开始",
    "classIsEnd": "班级报名已结束",
    "clickReset": "点击按钮，撤回报名",
    "agentRegister": "再次报名",
    "cancelRegister": "撤销报名",
    "reason": "原因",
    "inputReason": "请输入撤销原因",
    "homework": "作业",
    "leaveMaxBits": "请假原因最多不能超过100字",
    "leaveNotEndTime": "请假开始时间不能等于结束时间",
    "sizeNot": "大小不能超过",
    "close": "关闭",
    "teacher": "教师",
    "noIntroduction": "暂无简介"
  },
  "offlineclass": {
    "fullTimeToFace": "脱产面授",
    "onlineToFace": "在岗面授",
    "allClass": "全部班级",
    "openClass": "开放班级",
    "searchThoseClass": "搜索你感兴趣的面授培训班",
    "startLearn": "进入学习",
    "classHours": "班级学时",
    "h": "时",
    "firstWeek": "第1周",
    "askLeave": "我要请假",
    "monday": "星期一",
    "tuesday": "星期二",
    "wednesday": "星期三",
    "thursday": "星期四",
    "fridays": "星期五",
    "saturdays": "星期六",
    "sunday": "星期日",
    "morning": "上午",
    "afternoon": "下午",
    "evening": "晚上",
    "leaveType": "请假类型",
    "selectLeaveType": "请选择请假类型",
    "leaveTime": "请假时间",
    "selctLeaveTime": "请选择请假时间",
    "reasonLeave": "请假原因",
    "inputReasonLeave": "请输入请假原因",
    "sure": "确定",
    "selectTime": "选择时间",
    "casualLeave": "事假",
    "sickLeave": "病假",
    "seven": "日",
    "one": "一",
    "two": "二",
    "three": "三",
    "for": "四",
    "five": "五",
    "six": "六",
    "clear": "清空",
    "evaluating": "评估",
    "courseEvaluation": "教学评估",
    "inputEvaluating": "请输入评估内容",
    "beDoing": "进行时",
    "notStarted": "未开始",
    "evaluationInProgress": "评估进行中",
    "notEvaluation": "未评估",
    "evaluationStartTime": "评估开始时间",
    "startEvaluation": "开始评估",
    "classEvaluation": "班级评估",
    "photoCategory": "相册分类",
    "learningActivity": "学习活动",
    "addPhoto": "新增相片",
    "photoMessage": "相片信息",
    "photoName": "相片名称",
    "inputPhotoName": "请输入相片名称",
    "uploadPhoto": "相片上传",
    "formatSupport": "支持格式支持",
    "tickets": "张",
    "group": "小组",
    "notGroup": "未分组",
    "groupTalk": "分组研讨",
    "teacherAbout": "教师简介",
    "teacherTech": "所受课程",
    "photos": "相册",
    "phontoRequier": "照片必传",
    "addPhoneTips": "新增成功,请等待审核",
    "sureDelete": "你确认要删除吗",
    "deleteSuccess": "删除成功",
    "phoneNameReq": "相片名称项必填",
    "longNotBits": "长度不能超过50个字符",
    "phoneIsOccur": "相片名称已经存在",
    "evaluateTime": "评估时间",
    "evalueteNotStar": "评估未开始",
    "evaluateEnds": "评估已结束",
    "isEvaluated": "已评估",
    "at": "于",
    "submit": "提交",
    "seeEvalute": "查看评估",
    "inputIdea": "请输入你的想法",
    "submitFailure": "交卷失败",
    "seeRecord": "查看记录",
    "examRecord": "考试记录",
    "seeSubmite": "查看试卷",
    "resultPage": "考试结果页面",
    "hoursStandard": "学时未达标，不能参加考试",
    "examPage": "考试页面",
    "questionnaire": "调查问卷",
    " coursesTaught": "所授课程",
    "passed": "通过",
    "is": "是",
    "not": "否",
    "passedState": "通过状态",
    "sketch": "草稿",
    "partySchool": "党校培训班",
    "searchPartySchool": "搜索你感兴趣的党校培训班"
  },
  "exam": {
    "answerWarning": "本次考试题目为单题不可逆，下一题之前请慎重",
    "inputAnswerTips": "请输入您的答案",
    "problemPoints": "题点解析",
    "examination": "报名考试",
    "knowledgeCompetition": "知识竞赛",
    "practice": "自主练习",
    "notRegister": "未报名",
    "reviewAudit": "审核中",
    "auditNoPass": "审核未通过",
    "participanted": "已报名",
    "participant": "报名",
    "examTime": "考试时间",
    "examHours": "时长",
    "registration": "报名成功",
    "reRegistration": "撤回报名",
    "wrongQuestion": "错题库",
    "noInvolvement": "未参与",
    "involvement": "已参与",
    "searchExamPractice": "搜索你感兴趣的考试和练习",
    "practiced": "已练习",
    "startPractice": "开始练习",
    "toFavorite": "加入收藏",
    "prevPrevious": "上一题",
    "nextPrevious": "下一题",
    "submitAnswers": "提交答案",
    "rightAnswers": "正确答案",
    "yourAnswers": "您的答案",
    "questionsAnalysis": "试题解析",
    "noAnalysis": "暂无解析",
    "accuracy": "正确率",
    "continuePracticed": "继续练习",
    "topics": "题目"
  },
  "source": {
    "allResource": "全部资源",
    "commonResource": "通用资源",
    "classResource": "班级资源",
    "resourceCategory": "资源分类",
    "searchResource": "搜索你感兴趣的资源",
    "resourceTalk": "资源评价",
    "previewResource": "资源预览",
    "helpPoint": "帮助手册",
    "isEvaluation": "您已经评价过了！",
    "selectEvaluation": "您未选择评分！",
    "evaluationSuccess": "评价成功",
    "topRelise": "置顶",
    "className": "班级名称",
    "resourceEvaluation": "资源评分"
  },
  "usercenter": {
    "386": "学习档案",
    "myCourse": "我的课程",
    "hours": "时",
    "loginAccount": "登录账号",
    "htllo": "您好",
    "welcomeMessage": "祝您开心每一天",
    "underway": "你正在进行",
    "annualAssessment": "年年度考核",
    "searchTips": "输入搜索的课程名称",
    "completed": "已学完",
    "allCourses": "全部课程",
    "requiredCourses": "必修课程",
    "electiveCourses": "选修课程",
    "all": "全部",
    "ongoing": "进行中",
    "learnTo": "学习至",
    "inExams": "参加考试",
    "noExams": "暂无考试",
    "delete": "删除",
    "pleaseSelect": "请选择",
    "searchOnlineTips": "搜索你感兴趣网上专题班",
    "passedCourse": "已通过",
    "failedCourse": "未通过",
    "myOnlineCourse": "我的网上专题班",
    "myFaceCourse": "我的面授培训班",
    "searchFaceTips": "搜索你感兴趣的课程",
    "myExams": "我的考试",
    "allExams": "全部考试",
    "makeUpExam": "待补考",
    "marking": "阅卷中",
    "onExam": "考试进行中",
    "passedExam": "考试已通过",
    "examHours": "考试时长",
    "examOver": "考试已结束",
    "exam": "考试",
    "examLog": "考试记录",
    "myScore": "我的得分",
    "surplusMakeUpExam": "剩余补考",
    "times": "次",
    "searchExamTips": "输入搜索的名称",
    "haveTime": "剩余时间",
    "question": "题",
    "eachQuestion": "每题",
    "score": "分",
    "examExplain": "考试说明",
    "confirmHandExams": "是否确认交卷",
    "autoSaveFailed": "自动保存失败",
    "autoSaveSuccess": "自动保存",
    "handExamsSuccess": "交卷成功",
    "yourScore": "您的得分",
    "noPublicAnswers": "本次考试将不公布答案",
    "noPublicResult": "此次试卷不公布",
    "reExam": "重新考试",
    "practice": "练习",
    "hasCollected": "已收藏",
    "emptyAnswer": "选项或作答内容不能为空",
    "isCorrect": "为正解",
    "myCollected": "我的收藏",
    "courseCollected": "课程收藏",
    "examCollected": "试题",
    "deleteCollected": "移除收藏",
    "myLeave": "我的请假",
    "allLeave": "全部请假",
    "needAudit": "待审核",
    "auditDate": "申请时间",
    "searchLeaveTips": "搜索你感兴趣的请假",
    "checkInfo": "查看详情",
    "cancelLeave": "撤销请假",
    "leaveInfo": "请假详情",
    "leaveState": "当前状态",
    "teamLeader": "小组长",
    "committeeMembers": "组织纪检委员",
    "headmaster": "班主任",
    "schoolLeader": "校领导",
    "student": "学员",
    "auditMessage": "审批原因",
    "onBusiness": "因公",
    "personal": "因私",
    "rejectReasons": "驳回原因",
    "confirmCancel": "确认是否撤销该请假",
    "cancelButton": "撤销",
    "cancelTitle": "撤销确认",
    "empty": "无",
    "wrongQuestionBank": "我的错题库",
    "searchWrongTips": "搜索你感兴趣的错题",
    "deleteWrongQuestion": "移除错题库",
    "myQuestionnaire": "我的问卷",
    "isCompleted": "已完成",
    "isOver": "已结束",
    "searchQuestionnaireTips": "输入搜索的问卷名称",
    "questionnaireDate": "问卷时间",
    "startQuestionnaire": "开始答卷",
    "checkQuestionnaire": "查看问卷",
    "allTeacher": "全部教师",
    "newTeacher": "新增教师",
    "searchTeacherTips": "搜索你感兴趣的教师",
    "checkTeacher": "查看",
    "editTeacher": "编辑",
    "workingIn": "任职于",
    "location": "常驻地点",
    "confirmDelete": "删除确认",
    "confirmDeleteTips": "是否确认删除",
    "recommendTeacher": "教师推荐",
    "addTeachers": "新增师资",
    "teacherInfo": "个人信息",
    "teacherName": "教师姓名",
    "workUnit": "任职单位",
    "contact": "联系方式",
    "teacherNameTips": "请输入师资姓名",
    "teacherWorkUnitTips": "请输入任职单位",
    "teacherContactTips": "请输入教师联系方式",
    "teacherLocationTips": "请输入常驻地点",
    "teacherDescTips": "请输入教师简介",
    "teachingInfo": "授课信息",
    "teachingExpertise": "授课专长",
    "fitLevel": "适合授课对象层级",
    "fitBusiness": "适合业务条线",
    "ruleNumber": "请输入8位(包括8)以内的整数",
    "rulePhone": "请输入正确的手机号",
    "ruleString": "请输入80位(包括80)以内的字符",
    "ruleIsNumber": "请输入数字",
    "pause": "暂存",
    "teachingStyle": "讲课风格",
    "teachingExpertiseTips": "请输入教师授课专长",
    "fitLevelTips": "请选择适合授课对象层级",
    "fitBusinessTips": "请选择适合业务条线",
    "chargeInfoTips": "请输入收费标准",
    "teachingStyleTips": "请输入教师讲课风格",
    "otherInfo": "其它信息",
    "recommendUnit": "推荐单位",
    "otherOption": "其它事项",
    "otherOptionTips": "请输入需要补充的其它事项",
    "isRequired": "此项必填",
    "pauseSuccess": "暂存成功",
    "phoneWrong": "请输入正确的手机号",
    "junior": "初中生",
    "highSchool": "高中生",
    "english": "英语",
    "mathematics": "数学",
    "recommendSuccessTips": "您已成功提交推荐的教师，审核通过后该教师将加入师资库",
    "goBackrecommend": "返回教师推荐",
    "checkTeacherInfo": "查看教师",
    "currentState": "当前状态",
    "chargeInfo": "收费标准",
    "myCertificate": "我的证书",
    "learningArchives": "学习档案",
    "allCertificate": "全部证书",
    "onlineCourse": "在线班",
    "faceCourse": "面授班",
    "exams": "考试",
    "baseInfo": "基础信息",
    "userName": "用户名",
    "name": "姓名",
    "company": "所在单位",
    "learningExperience": "学习履历",
    "assessmentIndex": "考核指标",
    "assessmentStatus": "考核状态",
    "assessmentTime": "考核时间",
    "onlineLearning": "在线学习",
    "year": "年度",
    "faceOutProduceHours": "面授脱产（学时）",
    "notFaceOutProduceHours": "非脱产面授（学时）",
    "onlineCenterLearnHours": "在线集中学习（学时）",
    "onlineSelfLearnHours": "在线自主学习（学时）",
    "outCompanyLearnHours": "外单位学习（学时）",
    "allHours": "总学时",
    "onlineSelfLearn": "自主在线学习",
    "onlineCentralizedLearning": "在线集中学习",
    "outCompanyLearn": "外单位学习",
    "faceTrain": "面授培训",
    "myNotice": "我的消息",
    "noticeSearchTips": "搜索你感兴趣的新闻",
    "systemNotice": "系统提醒",
    "message": "私信"
  },
  "questionnaire": {
    "notParticipat": "未参与",
    "description": "问卷说明",
    "save": "保存",
    "export": "导出",
    "printing": "打印",
    "handed": "交卷",
    "topics": "题目",
    "examList": "试题列表",
    "tableQuestions": "表格题",
    "newLine": "新增行",
    "deleteLine": "删除行",
    "sort": "序号",
    "content": "内容",
    "shortQuestion": "简答题",
    "inputContent": "请输入作答内容",
    "multiple": "多选题",
    "single": "单选题",
    "saveSuccess": "保存成功",
    "submitSuccess": "提交成功",
    "submitTips": "您已成功提交问卷，感谢你的参与",
    "closePage": "关闭此页"
  },
  "play": {
    "endStudy": "结束学习",
    "tips": "温馨提示",
    "playTips": "温馨提示：为保证您的学习时间被系统正常记录，请您点击右上角的“结束学习”按钮退出学习，如果直接关闭浏览器您的学习时间可能无法正常记录。",
    "notShowAgain": "不再提示此信息",
    "gotIt": "我知道啦",
    "chapter": "章节",
    "chapterText1": "第",
    "chapterText2": "章",
    "note": "笔记",
    "noteBlockTitle": "笔记",
    "evaluate": "评价",
    "evaluateStar": "星",
    "saveEvaluate": "提交",
    "notePlaceholder": "请输入笔记",
    "closeTips": "系统可能不会保存您所做的更改",
    "closeButton": "离开",
    "autoStop": "自动停止播放",
    "autoStopTips": "由于你长时间未有操作，系统自动停止了视频播放",
    "confirmOut": "您确定退出播放吗？",
    "closeOrNot": "是否关闭当前窗口",
    "noCoursePlay": "当前课程中无可播放课件",
    "attention": "请注意！"
  }
};